import React from "react";

const ProjectModal = ({ project, onClose }) => {
  const isVideo =
    project.siteUrl.endsWith(".mov") || project.siteUrl.endsWith(".mp4");

  return (
    <div className="modal">
      <div className="modal-content">
        <span className="close-button" onClick={onClose}>
          &times;
        </span>
        <div className="modal-media">
          {isVideo ? (
            <video controls>
              <source src={project.siteUrl} type="video/mp4" />
              <source src={project.siteUrl} type="video/quicktime" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <img src={project.imageUrl} alt={project.title} />
          )}
        </div>
        <div className="modal-details">
          <h3>{project.title}</h3>
          <p>{project.description}</p>
          <p>{project.taches}</p>
          <div className="project-links">
            <a href={project.siteUrl} target="_blank" rel="noopener noreferrer">
              Voir le site
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectModal;
